import { Auth } from 'aws-amplify'

const store = {
  namespaced: true,
  state: {
    user: null
  },
  mutations: {
    user (state, user) {
      state.user = user
    }
  },
  actions: {
    async fetchUser (context, user) {
      if (!user) {
        try {
          const getUser = await Auth.currentAuthenticatedUser()
          context.commit('user', getUser)
          window.localStorage.setItem('auth_token', getUser.getSignInUserSession().getAccessToken().getJwtToken())
        } catch (error) {
          context.commit('user', null)
        }
      } else {
        context.commit('user', user)
      }
      
    },
    async updateAuthToken (context) {
      if (!context.state.user || (context.state.user && context.state.user.getSignInUserSession().getAccessToken().payload.exp*1000 < (new Date()).getTime())) {
        await context.dispatch('fetchUser')
      } else {
        const token = context.state.user
          .getSignInUserSession()
          .getAccessToken()
          .getJwtToken()
        window.localStorage.setItem('auth_token', token)
      }
      
    },
    async updateTokenExpired (context, { callback }) {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser()
        const currentSession = await Auth.currentSession()
        cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
          if (err) {
            return
          }
          if (!session || !session.accessToken) return null
          const { accessToken } = session
          window.localStorage.setItem('auth_token', accessToken.jwtToken)
          callback()
          // do whatever you want to do now :)
        })
      } catch (e) {
        context.state.authorized = null
        context.state.user = null
      }
      // const token = context.state.user
      //   .getSignInUserSession()
      //   .getAccessToken()
      //   .getJwtToken()
      // context.state.token = token
    },

  },
  getters: {
    authToken: (state) => {
      if (!state.user) return null
      const token = state.user
        .getSignInUserSession()
        .getAccessToken()
        .getJwtToken()
      return `Bearer ${token}`
    },
    authConfig: (getters) => {
      let config = {}
      const token = getters.authToken
      if (token) {
        config = {
          headers: { Authorization: token }
        }
      }
      return config
    },
    getCurrentLoggedInUser(state){
      return state.user
    }
  }
}

export default store
